export type TaskItem = {
  id: number
  name: keyof TaskTexts
  kind: number
  reward: number
  pinned: boolean
  repeatable: boolean
  is_counter: boolean
  next_claim_available: string | null
  payload: {
    url?: string
    url_cis?: string
    maxCount?: number
    appid?: number
    name?: string
  }
  status: number
  width?: string
  minHeight?: string
  iconWidth?: number
  borderRadius?: number
  variant: 'completion' | 'counter'
  isCompleted?: boolean
  currentCount: number | null | undefined
  maxCount: number | null
}

export type TaskTexts = {
  addSteam: string
  addEpic: string
  gamedCommunity: string
  gamedChat: string
  addToHomeScreen: string
  tonConnect: string
  addEmoji: string
  boost: string
  friends3: string
  friends1: string
  xPost: string
  openSteamOn: string
  openPs5: string
  x: string
  friends5: string
  streaks: string
  tApps: string
  play: string
  postStory: string
  updateProgress: string
}

export enum TaskKind {
  MANUAL = 1,
  ADD_STEAM = 2,
  UPDATE_PROGRESS = 3,
  DAILY_PLAY = 4,
  FRIENDS = 5,
}

export enum TaskStatus {
  NOT_STARTED = 0,
  CHECK = 1,
  CLAIM = 2,
  DONE = 3,
}
